import React from 'react';
import SEO from '../components/SEO';
import { businessServices, itServices } from '../assets/data/servicesdata';
import ScrollReveal from '../components/ScrollReveal';
import CTASection from '../components/CTASection';
import '../styles/servicesPage.css';

function ServicePageCard({ service, delay }) {
  return (
    <ScrollReveal as="article" className="service-page-card" delay={delay}>
      <div className="service-page-icon">
        <ion-icon name={service.icon}></ion-icon>
      </div>
      <h3 className="service-page-title">{service.title}</h3>
      <p className="service-page-desc">{service.description}</p>
    </ScrollReveal>
  );
}

function ServicesPage() {
  return (
    <>
      <SEO
        title="Our Services"
        description="Explore QASHQ's business and IT consulting services including accounting, tax planning, business advisory, IT consulting, web development, and custom software solutions."
        path="/services"
      />
      <main className="services-page">
        <section className="page-hero services-page-header">
          <div className="container">
            <ScrollReveal className="page-hero-inner">
              <p className="section-eyebrow">Services</p>
              <h1 className="page-title">Comprehensive business &amp; IT consulting</h1>
              <p className="page-subtitle">
                Integrated services designed to strengthen operations, improve compliance, and
                accelerate digital capability.
              </p>
            </ScrollReveal>
          </div>
        </section>

        <section className="services-showcase">
          <div className="container">
            <div className="services-page-category">
              <div className="services-category-header">
                <span className="services-category-badge">Business</span>
                <h2 className="section-heading">Business Services</h2>
              </div>
              <div className="services-page-grid">
                {businessServices.map((service, index) => (
                  <ServicePageCard key={service.title} service={service} delay={index * 0.05} />
                ))}
              </div>
            </div>

            <div className="services-page-category">
              <div className="services-category-header">
                <span className="services-category-badge services-category-badge--it">Technology</span>
                <h2 className="section-heading">IT Services</h2>
              </div>
              <div className="services-page-grid">
                {itServices.map((service, index) => (
                  <ServicePageCard key={service.title} service={service} delay={index * 0.05} />
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="why-choose-section">
          <div className="container">
            <ScrollReveal className="why-choose-header">
              <p className="section-eyebrow">Why QASHQ</p>
              <h2 className="section-heading">Why choose QASHQ</h2>
            </ScrollReveal>

            <div className="benefits-grid">
              {[
                {
                  icon: 'people-outline',
                  title: 'Expert Team',
                  text: 'Experienced professionals across accounting, advisory, and technology delivery.',
                },
                {
                  icon: 'link-outline',
                  title: 'Integrated Solutions',
                  text: 'Financial and IT services aligned under one trusted consulting partner.',
                },
                {
                  icon: 'headset-outline',
                  title: 'Responsive Support',
                  text: 'Accessible support when your team needs guidance or resolution.',
                },
                {
                  icon: 'shield-checkmark-outline',
                  title: 'Compliance Assured',
                  text: 'Structured processes that support regulatory and operational requirements.',
                },
                {
                  icon: 'construct-outline',
                  title: 'Tailored Approach',
                  text: 'Solutions shaped around your business model, stage, and priorities.',
                },
                {
                  icon: 'trophy-outline',
                  title: 'Proven Delivery',
                  text: 'Trusted by growing organizations with a consistent standard of execution.',
                },
              ].map((item, index) => (
                <ScrollReveal key={item.title} as="article" className="benefit-card" delay={index * 0.06}>
                  <div className="benefit-icon">
                    <ion-icon name={item.icon}></ion-icon>
                  </div>
                  <h3 className="benefit-title">{item.title}</h3>
                  <p className="benefit-text">{item.text}</p>
                </ScrollReveal>
              ))}
            </div>
          </div>
        </section>

        <CTASection
          title="Ready to Transform Your Business?"
          text="Get in touch with QASHQ today to discuss your business or technology goals."
          primaryLabel="Book a Free Consultation"
        />
      </main>
    </>
  );
}

export default ServicesPage;
